import axiosClient from "@/shared/lib/axios/axios";
import { API_ROUTES } from "../config";
import {
  ClassificationReviewItem,
  ReviewActivityItem,
  ReviewFilters,
  ReviewPaginatedResponse,
  SingleReviewPayload,
  BatchReviewPayload,
} from "../../types/review";

export const getReviewClassifications = async (
  params: ReviewFilters
): Promise<ReviewPaginatedResponse<ClassificationReviewItem[]>> => {
  const res = await axiosClient.get<ReviewPaginatedResponse<ClassificationReviewItem[]>>(
    API_ROUTES.REVIEW_CLASSIFICATIONS,
    { params }
  );
  return res.data;
};

export const getReviewDetail = async (
  imageId: number
) => {
  const res = await axiosClient.get(`${API_ROUTES.REVIEW_CLASSIFICATIONS}${imageId}/`);
  return res?.data?.data ?? res?.data;
};

export const reviewClassification = async (imageId: number, payload: SingleReviewPayload) => {
  return axiosClient
    .post(`${API_ROUTES.REVIEW_CLASSIFICATIONS}${imageId}/review/`, payload)
    .then((res) => res.data);
};

export const batchReviewClassifications = async (payload: BatchReviewPayload) => {
  return axiosClient
    .post(`${API_ROUTES.REVIEW_CLASSIFICATIONS}batch-review/`, payload)
    .then((res) => res.data);
};

export const getReviewActivity = async (limit = 10) => {
  const res = await axiosClient.get<{ data: ReviewActivityItem[] }>(
    API_ROUTES.REVIEW_ACTIVITY,
    { params: { limit } },
  );
  return res.data.data;
};
